import React, { useEffect, useState } from 'react';
import { Image, Pressable, useWindowDimensions, View } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import type { QualityWarningSummaryDto } from '../../../api/api.g';
import useTranslation from '../../../hooks/translation-hook';
import Label from '../Label';
import Popup from '../Popup';
import CustomButton from '../CustomButton';
import QualityWarningContent from './QualityWarningContent';

interface Props {
  warning: QualityWarningSummaryDto;
  onClose(): void;
  onDisplay(): void;
  onAcknowledge(): Promise<void>;
}

export default function QualityWarningPopup({ warning, onClose, onDisplay, onAcknowledge }: Props) {
  const t = useTranslation();
  const { width } = useWindowDimensions();
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => { onDisplay(); }, [onDisplay]);
  const acknowledge = async () => {
    if (busy) return;
    setBusy(true); setFailed(false);
    try { await onAcknowledge(); } catch { setFailed(true); }
    finally { setBusy(false); }
  };
  return <Popup screenMargins={false} backgroundColor="#FEF1DD" borderRadius={10}>
    <View testID="quality-warning-popup" style={{ width: Math.min(350, Math.max(0, width - 40)), maxWidth: '100%', backgroundColor: '#FEF1DD', borderRadius: 10, overflow: 'hidden' }}>
      <Image source={require('../../../../assets/quality-warning.png')} accessible={false}
        resizeMode="contain" style={{ width: '100%', aspectRatio: 350 / 234 }} />
      <Pressable accessibilityRole="button" accessibilityLabel={t('close')} onPress={onClose} disabled={busy}
        style={{ position: 'absolute', top: 0, right: 0, width: 44, height: 44, alignItems: 'center', justifyContent: 'center' }}>
        <FontAwesomeIcon icon={faXmark} size={20} color="#111111" />
      </Pressable>
      <View style={{ paddingHorizontal: 28, paddingBottom: 28, gap: 12 }}>
        <View accessible accessibilityRole="header">
          <Label numberOfLines={0} style={{ color: '#43A49E', fontSize: 26, lineHeight: 30, fontWeight: '700', textAlign: 'center', marginTop: 13 }}>
            {t('quality-warning-title')}
          </Label>
        </View>
        <QualityWarningContent centered />
        {failed && <View accessible accessibilityRole="alert"><Label numberOfLines={0} style={{ color: '#9D123A', textAlign: 'center' }}>{t('Something-went-wrong-please-try-again-later')}</Label></View>}
        {!warning.acknowledgedAtUtc && <CustomButton title={t('quality-warning-acknowledge')} accessibilityRole="button" onPress={acknowledge} disabled={busy}
          accessibilityState={{ busy, disabled: busy }} style={{ backgroundColor: '#F5A523', minHeight: 44, alignSelf: 'center', maxWidth: '100%', paddingHorizontal: 24 }}
          contentStyle={{ flex: 0, height: 'auto' }}
          textStyle={{ color: 'white', textAlign: 'center', flexShrink: 1 }} />}
      </View>
    </View>
  </Popup>;
}
